module.exports = __webpack_public_path__ + "static/media/javacustomerinfo.c4f50259.PNG";